import { Directive, ElementRef, Input } from '@angular/core';
import * as anime from 'animejs/lib/anime';

@Directive({
  selector: '[fade]'
})
export class FadeDirective {
  @Input() time: number = 5500;
  private animation: any;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.animation = anime({
      targets: [this.el.nativeElement],
      duration: 1,
      opacity: 0
    })
      .add({
        opacity: 1,
        duration: this.time,
        easing: 'easeInOutSine',
      });
  }

  ngAfterViewInit() {
    this.animation.play();
  }
}